var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import { Cancel } from '../icon';
import keycode from 'keycode';

var focusLeftOrRight = function focusLeftOrRight(event, leftKeys, rightKeys) {
  // go left
  if (leftKeys.indexOf(event.which) > -1) {
    if (event.target.previousSibling) {
      return event.target.previousSibling.focus();
    }
    return event.target.parentNode.lastChild.focus();
  }
  // go right
  if (rightKeys.indexOf(event.which) > -1) {
    if (event.target.nextSibling) {
      return event.target.nextSibling.focus();
    }
    return event.target.parentNode.firstChild.focus();
  }
};

// input fields which handles all logic

var Chip = function (_React$Component) {
  _inherits(Chip, _React$Component);

  function Chip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Chip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Chip.__proto__ || Object.getPrototypeOf(Chip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inputValue: ''
    }, _this.onKeyPress = function (event) {
      var text = _this.state.inputValue.trim();
      if (_this.props.delimiters.indexOf(event.which) > -1 && text !== '') {
        // empty input field
        _this.setState({
          inputValue: ''
        });
        // notify parent component
        _this.props.onChange([].concat(_toConsumableArray(_this.props.value), [{ text: text }]));
      }
    }, _this.onKeyDown = function (event) {
      // toggle through chips when input field is empty and when we have some chips to toggle through
      if (_this.state.inputValue !== '' || !_this.props.value.length) {
        return;
      }
      if (event.which === keycode('backspace')) {
        // prevent window.history.back() for backspace (for example)
        event.preventDefault();
      }
      return focusLeftOrRight(event, [keycode('backspace'), keycode('left')], [keycode('right')]);
    }, _this.onChange = function (event) {
      _this.setState({ inputValue: event.target.value });
    }, _this.onDelete = function (target, index) {
      // remove focused chip
      var value = [].concat(_toConsumableArray(_this.props.value.slice(0, index)), _toConsumableArray(_this.props.value.slice(index + 1)));
      // focus appropriate element
      if (value.length === 0) {
        // focus input field when all chips are gone
        _this.input.focus();
      } else if (value.length === index) {
        // if last chip is deleted select chip to the left
        target.previousSibling.focus();
      }
      // notify parent component
      _this.props.onChange(value);
    }, _this.onWrapperClick = function (event) {
      // do not handle click events on children, e.g. chips
      if (event.target === event.currentTarget && _this.input) {
        _this.input.focus();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // KeyPress event is invoked only for character (printable) keys.
  // That's why we need KeyDown event for backspace and arrow keys.


  _createClass(Chip, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        {
          className: 'mdc-Chip-wrapper',
          onClick: this.onWrapperClick
        },
        this.props.value.map(function (chip, i) {
          return React.createElement(Element, {
            key: i,
            index: i,
            text: chip.text,
            icon: chip.icon,
            onDelete: _this2.props.onChange && _this2.props.deletable && _this2.onDelete,
            onFocus: _this2.props.onFocus,
            onBlur: _this2.props.onBlur
          });
        }),
        this.props.onChange && React.createElement('input', {
          className: 'mdc-Chip-input',
          type: 'text',
          onKeyPress: this.onKeyPress,
          onKeyDown: this.onKeyDown,
          value: this.state.inputValue,
          onChange: this.onChange,
          ref: function ref(c) {
            _this2.input = c;
          },
          onFocus: this.props.onFocus,
          onBlur: this.props.onBlur,
          autoFocus: this.props.autoFocus,
          placeholder: this.props.placeholder
        })
      );
    }
  }]);

  return Chip;
}(React.Component);

Chip.propTypes = {
  autoFocus: PropTypes.bool,
  deletable: PropTypes.bool,
  delimiters: PropTypes.arrayOf(PropTypes.number),
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.object)
};
Chip.defaultProps = {
  deletable: true,
  delimiters: [keycode('enter')],
  value: []
};
export default Chip;


var Element = function Element(_ref2) {
  var autoFocus = _ref2.autoFocus,
      icon = _ref2.icon,
      index = _ref2.index,
      onBlur = _ref2.onBlur,
      onDelete = _ref2.onDelete,
      onFocus = _ref2.onFocus,
      text = _ref2.text;

  var textStyle = {
    marginLeft: icon ? 8 : 12,
    marginRight: onDelete ? 0 : 12
  };
  var onKeyDown = function onKeyDown(event) {
    if (onDelete && (event.which === keycode('backspace') || event.which === keycode('delete'))) {
      event.preventDefault();
      return onDelete(event.target, index);
    }
    return focusLeftOrRight(event, [keycode('left')], [keycode('right')]);
  };

  return React.createElement(
    'div',
    {
      className: 'mdc-Chip',
      tabIndex: '0',
      onFocus: onFocus,
      onBlur: onBlur,
      onKeyDown: onKeyDown
    },
    icon ? React.createElement(
      'div',
      { className: 'mdc-Chip-icon' },
      icon
    ) : null,
    React.createElement(
      'span',
      { style: textStyle },
      text
    ),
    onDelete ? React.createElement(
      'button',
      {
        type: 'button',
        tabIndex: '-1',
        className: 'mdc-Chip-delete',
        onClick: function onClick(event) {
          onDelete(event.currentTarget.parentElement, index);
        }
      },
      React.createElement(Cancel, { className: 'mdc-Chip-delete-icon' })
    ) : null
  );
};


//////////////////
// WEBPACK FOOTER
// ../es/js/chip/index.js
// module id = 285
// module chunks = 0